module.exports = __webpack_public_path__ + "img/active.a98d8256.svg";